/**
 * en-GB messages added by Phase 3 task S32 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s32EnGB = {
    'permits.annotation.open': 'Open permit to work',
    'permits.error.state': 'This permit cannot be changed from its current status.',
    'permits.error.compliance': 'This person cannot be given a permit yet: {items} needs attention.',
    'permits.error.type': 'Choose an active permit type.',
    'permits.error.site_mismatch': 'The visit, pre-registration or site does not match.',
    'permits.error.times': 'The permit must end after it starts.',
    'permits.error.max_hours': 'This permit type can last at most {maxHours} hours.',
    'permits.error.checklist': 'Every required checklist item must be ticked before a permit is issued.',
    'permits.error.signature': 'A drawn signature is needed.',
    'permits.error.signature_duplicate': 'Each role can sign only once.',
    'permits.error.signature_missing': 'A signature is missing for a required role.',
    'permits.error.ended': 'This permit has passed its end time and cannot be resumed.',
    'permits.error.not_yours': 'That permit is not yours to accept.',
};
//# sourceMappingURL=s32.js.map